<div [ngClass]="auth.isPremium() ? 'premium-vertical' : 'basic-vertical'">
  <div id="textImgRow" class="row">
      <div id="sideImgText" class="col-6">
          <h4 id="leftTitle" class="title inverted font-extrabold">{{headerText()}}</h4>
          <p class="ptext font-bold" style="font-size: 18px;">{{boxText()}}</p>
          <mat-list role="list" paint="#ffffff">
            @for(feature of features(); track feature){
              <mat-list-item role="listitem">
                <mat-icon matListItemIcon>check_circle</mat-icon>
                <span matListItemTitle style="white-space: normal !important;">{{feature}}</span>
              </mat-list-item>
            }
          </mat-list>
          <div class="store-ctas">
            @if(!meta.platform.IOS){
              <a href="https://play.google.com/store/apps/details?id=app.cloudigo.cloudigo" target="_blank">
                  <img src="old/playstore-btn.png" alt="Get cloudigo on the playstore"/>
              </a>
            }
            @if(!meta.platform.ANDROID){
              <a href="https://apps.apple.com/mt/app/cloudigo/id1440612925" target="_blank">
                  <img src="old/appstore-btn.png" alt="Get cloudigo on the appstore"/>
              </a>
            }
        </div>
      </div>
      <div class="col-6 imgCol">
          <img class="sideImg" src="old/homev2/signupImg.webp" alt="App on Phone"/>
      </div>
  </div>
</div>